export default __webpack_public_path__ + "static/color-analysis-eye-colors-d766a1080a70214c99301a4d03700770.jpg";